
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"42","height":"42"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('circle',{attrs:{"data-name":"Ellipse 994","cx":"21","cy":"21","transform":"rotate(-90 21 21)","stroke":"#707070","stroke-linecap":"round","stroke-width":"2","fill":"#fff","r":"21"}})])]),_c('g',{attrs:{"data-name":"Mask Group 85"}},[_c('g',{attrs:{"data-name":"Group 6366","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 4972","d":"M21 0a21 21 0 1021 21A21.024 21.024 0 0021 0zm5.223 21.739h-3.417v12.178h-5.063V21.739h-2.406v-4.3h2.407v-2.787c0-1.994.947-5.109 5.109-5.109l3.752.014v4.178h-2.724a1.031 1.031 0 00-1.073 1.172v2.529h3.857z","fill":"#fff"}})])])])
          )
        }
      }
    